import {
  getFetchedJSON,
  fetchWithState,
  fetchWithStateTL,
} from '~/misc/fetch';
import {formatNumberOnly} from '~/misc/formatPhone';
import vipShownameTransfer from '~/components/pages/vipShownameTransfer.js';

export const getPamentInfoApi = (getState) => fetchWithStateTL(getState, {
  method: 'GET',
  header: {
    'Cache-control': 'no-cache',
    'Pragma': 'no-cache',
  },
  url: '/pay-options/service',
}).then(getFetchedJSON);

export const queryAccountOrNotApi = (getState, email) => fetchWithState(getState, {
  method: 'GET',
  header: {
    'Cache-control': 'no-cache',
    'Pragma': 'no-cache',
  },
  url: `/tl/vip/query?email=${email}`,
}).then(getFetchedJSON);

export const saveDirectOrderInfoApi = (getState, val) => {
  val.billFirstName = val.billFirstname || '';
  val.billLastName = val.billLastname || '';
  delete val.billFirstname;
  delete val.billLastname;
  val.plan = val.plan ? vipShownameTransfer[val.plan.toLowerCase()] : '';
  return fetchWithState(getState, {
    method: 'POST',
    url: '/tl/direct/order',
    body: val,
  }).then(getFetchedJSON);
};

export const getDirectOrderInfoApi = (getState, email) => fetchWithState(getState, {
  method: 'GET',
  header: {
    'Cache-control': 'no-cache',
    'Pragma': 'no-cache',
  },
  url: `/tl/direct/order?email=${email}`,
}).then(getFetchedJSON);



// WEBPACK FOOTER //
// ./src/modules/createAccount/api.js